import { isMobile as isMobileSelector } from 'components/Shared/responsive';
import { getNextPage, getTotalCount } from 'views/EditorialPage/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { getEditorialsAction, getMoreEditorialsAction } from 'views/EditorialPage/actions';
import { getRootCategoryUrl } from 'views/ProductlistPage/selectors';
import { RefObject } from 'react';
import { Paging } from 'components/Paging';
import { scrollToTarget, rm } from 'utils';

interface EditorialPagingProps {
  anchorRef: RefObject<HTMLDivElement>;
}

export const EditorialPaging = ({ anchorRef }: EditorialPagingProps) => {
  const dispatch = useDispatch();
  const totalArticles = useSelector(getTotalCount);
  const nextPage = useSelector(getNextPage);
  const isMobile = useSelector(isMobileSelector);
  const rootCategoryUrl = useSelector(getRootCategoryUrl);
  const currentPage = nextPage - 1;
  const previousPage = currentPage - 1;
  const ARTICLES_PER_PAGE = 20;
  const amountOfPages = Math.ceil(totalArticles / ARTICLES_PER_PAGE);

  const visible = Math.min(totalArticles, currentPage * ARTICLES_PER_PAGE);

  const showLoadMore = currentPage < amountOfPages;
  const showPagePicker = totalArticles > ARTICLES_PER_PAGE;
  const showProgressBar = true;

  const loadMoreUrl = showLoadMore && isMobile ? `${rootCategoryUrl}?page=${nextPage}` : undefined;

  const scrollToTopIfNeeded = scrollToTarget(anchorRef);
  const gotoNextPage = () => dispatch(getEditorialsAction(nextPage)).then(scrollToTopIfNeeded);
  const gotoPrevPage = () => dispatch(getEditorialsAction(previousPage)).then(scrollToTopIfNeeded);
  const gotoPage = (page: number) => dispatch(getEditorialsAction(page)).then(scrollToTopIfNeeded);
  const showMore = () => dispatch(getMoreEditorialsAction());

  const progressBarDoneText = rm('editorials_you_have_seen_all_x_articles', totalArticles);
  const progressBarText = rm('editorials_you_have_seen_x_of_y_articles', visible, totalArticles);
  const loadMoreButtonText = rm('editorials_load_more');

  return (
    <Paging
      gotoPage={gotoPage}
      gotoPrevPage={gotoPrevPage}
      gotoNextPage={gotoNextPage}
      showMore={showMore}
      amountOfPages={amountOfPages}
      totalItems={totalArticles}
      visible={visible}
      currentPage={currentPage}
      loadMoreUrl={loadMoreUrl}
      rootCategoryUrl={rootCategoryUrl}
      showLoadMore={showLoadMore}
      showPagePicker={showPagePicker}
      showProgressBar={showProgressBar}
      loadMoreButtonText={loadMoreButtonText}
      progressBarDoneText={progressBarDoneText}
      progressBarText={progressBarText}
    />
  );
};
